import { motion } from "framer-motion";
import { SITE } from "@/lib/site";

export default function WhatsAppFAB() {
  return (
    <motion.a
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.6, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      href={`https://wa.me/${SITE.phoneRaw}?text=${SITE.waIntro}`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => {
        e.preventDefault();
        const url = `https://wa.me/${SITE.phoneRaw}?text=${SITE.waIntro}`;
        const w = window.open(url, "_blank", "noopener,noreferrer");
        if (!w) window.location.href = url;
      }}
      data-testid="whatsapp-floating-cta"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-40 group"
    >
      <span className="wa-pulse absolute inset-0 rounded-full" />
      <span className="relative flex h-14 w-14 md:h-16 md:w-16 items-center justify-center rounded-full bg-[#25d366] shadow-[0_20px_40px_-10px_rgba(37,211,102,0.55)] group-hover:scale-105 transition-transform duration-300">
        <svg
          viewBox="0 0 32 32"
          className="h-7 w-7 md:h-8 md:w-8 text-white"
          fill="currentColor"
          aria-hidden
        >
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.406-.545-.489-1.09-1.06-1.518-1.65-.101-.14-.335-.522-.335-.7 0-.294.156-.352.372-.55.216-.198.469-.352.685-.55.216-.176.335-.4.335-.702 0-.176-.372-1.106-.469-1.29-.101-.176-.216-.352-.315-.55-.126-.198-.335-.352-.545-.352h-.545c-.216 0-.469.101-.685.259-.216.176-.685.635-.685 1.65 0 1.017.685 2.036.802 2.212.101.176 1.518 2.212 3.607 3.098 2.09.886 2.09.7 2.475.7.335 0 1.09-.44 1.29-.86.176-.44.176-.86.101-.86-.101-.101-.216-.176-.469-.259zM16 3.2A12.8 12.8 0 0 0 3.2 16c0 2.263.582 4.401 1.68 6.36L3.2 28.8l6.612-1.68a12.8 12.8 0 1 0 6.188-23.92zm7.61 20.41A10.72 10.72 0 0 1 16 26.72c-1.94 0-3.85-.5-5.53-1.463l-.396-.223-4.09 1.043 1.075-4.03-.259-.415A10.72 10.72 0 1 1 23.61 23.61z" />
        </svg>
      </span>
    </motion.a>
  );
}
